// @flow

import React, { Component } from "react"
import { push } from "react-router-redux"
import { bindActionCreators } from "redux"
import Button from "react-toolbox/lib/button/Button"
import { connect } from "react-redux"

class NotFound extends Component {
  render () {
    return (
      <div>
        <h1>Not</h1>
        <p>Not Found!</p>
        <Button label="Default" />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => bindActionCreators( {
  changePage: () => push( "/about-us" ),
}, dispatch )

export default connect(
  null,
  mapDispatchToProps
)( NotFound )



// WEBPACK FOOTER //
// ./src/views/NotFound/index.jsx